<template>
	<nav class="sidebar" id="menu">
		<div class="sidebar__chatbot">
			<router-link :to="user.organization.is_mandatoaberto ? '/perfil' : '#'">
				<img :src="chatbotAvatar" class="user-image" alt="User Image" v-if="chatbotAvatar">
				<span v-if="user.name">{{ user.name}}</span>
			</router-link>
		</div>
		<ul class="menu" v-for="(category, index) in userMenu" :key="index">
			<li class="menu__title">{{ category.human_name }}</li>
			<li v-for="(menu, index) in category.sub_modules" :key="index">
				<router-link :to="menu.url" :class="menu.name" @click.native="scrollToTop">
					<i :class="menu.icon_class"></i>{{ menu.human_name }}
				</router-link>
			</li>
		</ul>

		<ul class="menu">
			<li class="menu__title">{{ 'menuConfig' | translate | capitalize }}</li>
			<li class=" menu__item">
				<a class="logout" @click.prevent="logout()">
					<i class="fas fa-sign-out-alt"></i>{{ 'sair' | translate | capitalize }}
				</a>
			</li>
		</ul>
	</nav>

</template>
<script>
import modulesConfigs from '../modules/config';

export default {
	name: 'sidebar',
	computed: {
		chatbotAvatar() {
			if (Object.keys((this.$store.state.user.facebook_active_page || {})).length) {
				return this.$store.state.user.facebook_active_page.picture.data.url;
			}
			return false;
		},
		user() {
			return this.$store.state.user;
		},
		apiModules() {
			const organizations = sessionStorage.getItem('organizations');
			return JSON.parse(organizations)[0].modules;
		},
		allConfigs() {
			return modulesConfigs.modulesConfigs;
		},
		menuOrder() {
			return modulesConfigs.menuOrder;
		},

		userMenu() {
			return this.apiModules.sort(this.compare);
		},
	},
	methods: {
		compare(a, b) {
			if (a.weight < b.weight) { return -1; }
			if (a.weight > b.weight) { return 1; }
			return 0;
		},
		logout() {
			this.$store.dispatch('signOut');
			this.$router.push('/');
		},
		createGroup() {
			this.$root.$emit('createGroup');
		},
		scrollToTop() {
			window.scrollTo(0, 0);
		},
	},
};
</script>




// WEBPACK FOOTER //
// _source/javascripts/components/sidebar.vue